// extracted by mini-css-extract-plugin
export var active = "_b7-d";
export var blink = "_b7-e";
export var container = "_b7-5";
export var controls = "_b7-0";
export var controlsRight = "_b7-1";
export var fakeCursor = "_b7-c";
export var hidden = "_b7-b";
export var quillContainerSmall = "_b7-7";
export var quillEditor = "_b7-6";
export var quillEditorSmall = "_b7-8";
export var quillFormatButtons = "_b7-a";
export var quillToolbar = "_b7-9";
export var removePadding = "_b7-2";
export var state = "_b7-3";
export var stateTitle = "_b7-4";